import { Component, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { PassengersService } from '../passengers.service';
import { StateService } from '@app/shared';
import { Observable } from 'rxjs';
import { debounceTime, map, filter, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-passengers',
  templateUrl: './passengers.component.html',
  styleUrls: ['./passengers.component.scss']
})
export class PassengersComponent implements OnInit {
  @ViewChild('controlMenu') controlMenu: TemplateRef<any>;
  @ViewChild('titlePage') titlePage: TemplateRef<any>;
  @ViewChild('query') queryRef: ElementRef;

  private options: any = {};
  service;
  passengers = [];
  history = [];
  taxiServices = [];
  displayedColumns = ['phone_number', 'name', 'balance', 'is_blocked', 'last_order', 'comment'];
  lastPage;
  ready;
  userType = 'operator';
  currentPassenger;
  title = 'PASSENGERS_TITLE';

  constructor(private passengerService: PassengersService, private state: StateService, private http: HttpClient) {}

  ngOnInit() {
    this.ready = false;
    this.http.get('operator/whoami').subscribe((res: any) => {
      this.userType = res.data.type;
    });
    this.state.getParameter('services').subscribe(res => {
      this.taxiServices = res;
      this.service = res[0].id;
      this.loadPassengers({ service: this.service });
    });

    Observable.fromEvent(this.queryRef.nativeElement, 'keyup')
      .pipe(
        debounceTime(600),
        map((event: any) => event.target.value),
        map((el: string) => (el.length < 2 ? null : el)),
        map((el: string) => {
          if (el) {
            return el.replace('+380', '');
          }
        }),
        filter((event: string) => !event || !/^\d+$/.test(event) || this.userType == 'admin' || event.length >= 9)
      )
      .subscribe(text => this.loadPassengers({ query: text, page: 1 }));
  }

  loadPassengers(newOptions) {
    if (!newOptions.page) {
      newOptions.page = 1;
    }
    for (let key in newOptions) {
      if (key) {
        this.options[key] = newOptions[key];
        if (!this.options[key]) {
          delete this.options[key];
        }
      }
    }
    this.passengerService.getPassengers(this.options).subscribe((res: any) => {
      this.ready = true;
      if (this.options.page == 1) {
        this.passengers = res.data;
        document.getElementById('table').scrollTop = 0;
      } else {
        this.passengers = [...this.passengers, ...res.data];
      }
      this.lastPage = res.meta.last_page;
      this.currentPassenger = this.passengers[0];
      // const updatedVehicle = this.passengers.find(cab => cab.id == this.currentVehicle.id);
      // this.currentVehicle = updatedVehicle ? updatedVehicle : this.passengers[0];
    });
  }

  selectPassenger(passenger) {
    this.currentPassenger = passenger;
  }

  trackById(index, el) {
    return el.id;
  }

  blockedOnly(event) {
    this.loadPassengers({ is_blocked: event.checked ? 1 : 0, page: 1 });
  }

  scrollPage() {
    const nextPage = this.options.page + 1;
    this.loadPassengers({ page: nextPage });
  }

  updateService() {
    this.ready = false;
    this.loadPassengers({ service: this.service });
  }

  sortData($event) {}
}



// WEBPACK FOOTER //
// ./src/app/passengers/passengers/passengers.component.ts